import { useEffect } from "react";
import Button from "../components/Button";

const NotFound = () => {
  useEffect(() => {
    const el = document.querySelector("#switching-background-pattern");
    el.classList.add("hidden");

    return () => el.classList.remove("hidden");
  }, []);

  return (
    <div className="my:12 md:my-24">
      <div className="w-full max-w-[2000px] mx-auto relative flex justify-center items-center min-h-[500px]">
        <img
          src="/images/404.svg"
          className="absolute top-[-4px] left-[-5px] w-full h-full object-cover xl:object-contain"
        />
        <div className="relative flex flex-col items-center gap-4">
          <h1 className="text-[40px] leading-[48px] font-bold text-center text-white">
            Something <br />
            went wrong
          </h1>

          <Button to="/" variant="secondary">
            Back to home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
